import { useMemo } from "react";

import { GetCurrentCompanyQuery } from "@/graphql/generated/graphql";
import { GetCurrentCompany } from "@/graphql/queries/GetCurrentCompany";
import { useGraphQuery } from "@dashboard/library";
import {
  CurrentCompany,
  UseCurrentCompanyReturn,
} from "./useCurrentCompany.decl";

export function toCurrentCompany(
  company: GetCurrentCompanyQuery["getCompany"]
): CurrentCompany {
  return {
    ...company,
    id: Number(company.ID),
  };
}

/**
 * Hook to get the current company core data from getCompany.
 * Billing data lives in useCurrentCompanyBilling so consumers
 * that do not need it are not gated on the billing REST call.
 */
export function useCurrentCompany(): UseCurrentCompanyReturn {
  const { data, loading } =
    useGraphQuery<GetCurrentCompanyQuery>(GetCurrentCompany);

  const currentCompany = useMemo(() => {
    if (!data?.getCompany) {
      return undefined;
    }

    return toCurrentCompany(data.getCompany);
  }, [data]);

  return {
    loading,
    currentCompany,
  };
}
